<template>
	<div>
		<layout v-if="HasUser && LinksLoaded && !IsAuthenticated || IsAuthenticated && LinksLoadedAuth">
			<template #header>
				<nav-toolbar></nav-toolbar>
			</template>

			<template #main>
				<router-view></router-view>
			</template>

			<template #footer>
				<c-footer></c-footer>
			</template>
		</layout>
		<v-app v-else><spinner :loading="true"></spinner></v-app>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import errorActions from './store/actions/error';
import userActions from './store/actions/user';
import rootActions from './store/actions/root';
import namespace from './store/namespace';

import Layout from './general/Layout.vue';
import NavToolbar from './navigation/Toolbar.vue';
import Spinner from './general/Spinner.vue';
import CFooter from './general/Footer.vue';

export default {
	name: 'app',
	components: {
		Layout,
		NavToolbar,
		Spinner,
		CFooter,
	},
	async created() {
		await this.GET_ROOT_LINKS();

		if (this.IsAuthenticated) {
			await this.GET_ROOT_LINKS_AUTH();
			await this.GET_CURRENT_USER();
		}
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(namespace.USER, ['HasUser']),
		...mapGetters(['LinksLoaded', 'LinksLoadedAuth']),
	},
	methods: {
		...mapActions([rootActions.GET_ROOT_LINKS,
			rootActions.GET_ROOT_LINKS_AUTH]),
		...mapActions(namespace.USER, [userActions.GET_CURRENT_USER]),
		...mapActions(namespace.ERROR, [errorActions.SET_ERROR]),
	},
	async errorCaptured(err, comp, details) {
		console.log(err, comp, details);
		if (!err.response) {
			if (err.message.includes('response is undefined')) {
				this.SET_ERROR(this.$i18n.t('text.error500'));
			} else {
				this.SET_ERROR(err.message);
			}
		} else {
			switch (err.response.status) {
			case 403:
				this.SET_ERROR(this.$i18n.t('text.error403')); break;
			case 404:
				this.SET_ERROR(this.$i18n.t('text.error404')); break;
			case 400:
				this.SET_ERROR(this.$i18n.t('text.error400')); break;
			case 422:
				this.SET_ERROR(this.$i18n.t('text.error422')); break;
			case 500:
				this.SET_ERROR(this.$i18n.t('text.error500')); break;
			default: this.SET_ERROR(err.message); break;
			}
		}

		return false;
	},
};
</script>

<style>
body {
	background-color: #333;
    margin: 0;
    padding: 0;
    background-attachment: fixed;
}

.footer {
	color: #fff;
}
</style>
